import HttpService from '../../infra/http/AxiosConfig';

import { formatToNumber } from '../NumberService';

export function ConfiguracaoService() {
  function update({
    id,
    raioAtual,
    percentualContribuicao,
    desativadaValidacaoSMS,
    servicoSMS,
    tempoEnvio,
    tempoCancelamento,
    habilitarCupom,
    indiqueGanheEstaAtivo,
    valorIndiqueGanhe,
    tempoLimiteIndiqueGanhe,
    percentualTaxaPagamentoApp,
    percentualTaxaAntecipacao,
    taxaServico,
    taxaCancelamento,
    valorBonusNovoCliente,
    tempoLimiteEsperaCliente,
    valorBonusPedidoAtrasado,
    taxaEsperaCliente
  }) {
    return HttpService.AxiosClient.put('configuracoes', {
      id,
      distancia: formatToNumber(raioAtual),
      percentualContribuicao: formatToNumber(percentualContribuicao),
      tempoEnvio: tempoEnvio,
      tempoCancelamento: tempoCancelamento,
      habilitarCupom: habilitarCupom,
      desativadaValidacaoSMS,
      servicoSMS,
      indiqueGanheEstaAtivo,
      valorIndiqueGanhe,
      tempoLimiteIndiqueGanhe,
      percentualTaxaPagamentoApp: formatToNumber(percentualTaxaPagamentoApp),
      percentualTaxaAntecipacao: formatToNumber(percentualTaxaAntecipacao),
      taxaServico: formatToNumber(taxaServico),
      taxaCancelamento: formatToNumber(taxaCancelamento),
      valorBonusNovoCliente: formatToNumber(valorBonusNovoCliente),
      tempoLimiteEsperaCliente: tempoLimiteEsperaCliente,
      valorBonusPedidoAtrasado: formatToNumber(valorBonusPedidoAtrasado),
      taxaEsperaCliente: formatToNumber(taxaEsperaCliente)
    });
  }

  return { update };
}
